module.exports = __webpack_public_path__ + "static/media/Tommen Baratheon 2.f64e91b4.jpg";